import { Lightning, Router } from '@lightningjs/sdk'
import { getColor, grey50, grey920 } from '../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../constants/fonts'
import { BORDER_RADIUS } from '../../constants/general'
import { Images } from '../../constants/paths'
import { BASE_ROUTES } from '../../constants/routes'
import { getAsset, getIcon } from '../../utils/image'
import { captureClick, SEGMENT_TRACK_EVENTS } from '../../utils/segmentAnalytics'
import TvBaseCard from './TvBaseCard'

const DASHED_CIRCLE_SIZE = 140
const ICON_SIZE = 48
const CONTAINER_PADDING = 40
const LOGO_HEIGHT = 193
const LOGO_WIDHT = 245
const GRADIENT_WIDTH = 1327
const GRADIENT_HEIGHT = 220

export default class TvBannerMessage extends TvBaseCard {
  static _template() {
    return {
      ...super._template(),
      LogoOutline: {
        mountX: 1,
        mountY: 1,
        texture: Lightning.Tools.getSvgTexture(
          getAsset(Images.LOGO_OUTLINE_PARTIAL),
          LOGO_WIDHT,
          LOGO_HEIGHT,
        ),
      },
      FocusGradient: {
        mountX: 1,
        visible: false,
        texture: Lightning.Tools.getSvgTexture(
          getAsset(Images.BANNER_MESSAGE_FOCUS_GRADIENT),
          GRADIENT_WIDTH,
          GRADIENT_HEIGHT,
        ),
      },
      Container: {
        w: (w) => w - CONTAINER_PADDING * 2,
        h: (h) => h - CONTAINER_PADDING * 2,
        rect: true,
        color: getColor(grey920),
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: BORDER_RADIUS,
        },
        flex: {
          direction: 'row',
          paddingLeft: CONTAINER_PADDING,
          paddingRight: CONTAINER_PADDING,
          paddingTop: CONTAINER_PADDING,
          paddingBottom: CONTAINER_PADDING,
        },

        DashedCircle: {
          flexItem: {
            marginRight: 64,
          },
          texture: Lightning.Tools.getSvgTexture(
            getAsset(Images.DASHED_CIRCLE),
            DASHED_CIRCLE_SIZE,
            DASHED_CIRCLE_SIZE,
          ),

          Icon: {
            mount: 0.5,
            x: DASHED_CIRCLE_SIZE / 2,
            y: DASHED_CIRCLE_SIZE / 2,
          },
        },
        Message: {
          flex: {
            direction: 'column',
          },

          Title: {
            flexItem: {
              marginBottom: 16,
            },
            text: {
              text: '',
              textColor: getColor(grey50),
              fontFace: UniNeueBold,
              fontSize: 48,
              maxLines: 1,
              maxLinesSuffix: '...',
              lineHeight: 56,
            },
          },
          Subtitle: {
            text: {
              text: '',
              textColor: getColor(grey50),
              fontFace: UniNeueRegular,
              fontSize: 32,
              maxLines: 1,
              maxLinesSuffix: '...',
              lineHeight: 36,
            },
          },
        },
      },
    }
  }

  get title() {
    return this.tag('Title')
  }

  get subtitle() {
    return this.tag('Subtitle')
  }

  get icon() {
    return this.tag('Icon')
  }

  get focusGradient() {
    return this.tag('FocusGradient')
  }

  get logoOutline() {
    return this.tag('LogoOutline')
  }

  get speechText(): string {
    return this.data?.title?.text
  }

  _active() {
    this.renderCardData()
  }

  _getFocused() {
    return this
  }

  _focus() {
    super._focus()
    this.focusGradient.patch({
      visible: true,
    })
  }

  _unfocus() {
    super._unfocus()
    this.focusGradient.patch({
      visible: false,
    })
  }

  _handleEnter() {
    void captureClick(SEGMENT_TRACK_EVENTS.ButtonClicked, this.data?.action?.analytics)
    Router.navigate(BASE_ROUTES.EDIT_FAVORITES)
  }

  renderCardData() {
    this.title.patch({
      text: {
        text: this.data?.title?.text,
      },
    })
    this.subtitle.patch({
      text: {
        text: this.data?.subtitle?.text,
      },
    })
    this.icon.patch({
      texture: Lightning.Tools.getSvgTexture(
        getIcon(this.data?.leading_icon?.style),
        ICON_SIZE,
        ICON_SIZE,
      ),
    })
    this.logoOutline.patch({
      x: this.w,
      y: this.h,
    })
    this.focusGradient.patch({
      x: this.w,
    })
  }

  _handleHover() {
    this.fireAncestors('$updateFocusByHover', this)
    this._focus()
  }

  _handleUnhover() {
    this._unfocus()
  }

  _handleClick() {
    this._handleEnter()
  }
}
